export default "__VITE_ASSET__BNz70Hjj__"